// extracted by mini-css-extract-plugin
export default {"card":"h5-z"};